import { useEffect, useState } from "react";
import { Autocomplete, Box, FormControl, ListItemText, TextField, } from "@mui/material";
import "./style.css";
import EnvironmentalRiskScore from "./EnvironmentalRiskScore";
import DailyAlert from "./DailyAlert";
import SubstanceFrequency from "./SubstanceFrequency";
import RecentNotification from "./RecentNotification";
import SubstanceRiskLongevity from "./SubstanceRiskLongevity";

import { Pages } from "./drag&drop/Pages";
import { Layout } from "./drag&drop/Page";
import { ComponentDataType, ItemType, SelectedFacilityType } from "./types";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { getDashboardWidgetsSorting, getRecentNotificationData, saveDashboardWidgetsSorting } from "../../store/thunk/mainDashboardThunk";
import CustomHeader from "../pageHeader/Index";
import { setTenantId } from "../../store/thunk/commonThunk";
import { getTenantDropDownList, updateTenantInfoThunk } from "../../store/thunk/tenantThunk";
import { getLocationLists } from "../../store/thunk/locationThunk";
import { LabelIcons } from "../newDashboard/Svg/labelIcons";
import EnvironmentRiskChart from "./EnvironmentRiskChart";
import { getSubstabceConfiguration } from "../../store/thunk/categorySubstanceThunk";
import { notificationFail } from "../../store/slices/notificationSlice";
import { setMainDashboardInitialState, setMainDashboardLoaderFalse } from "../../store/slices/mainDashboardSlice";

export type TenantValueType = {
  tenantCode: string;
  tenant_name: string;
  tenantId: string;
}
const Dashboard = () => {
  const { userData } = useAppSelector((state) => state.authReducer);
  const tenantDropDownList = useAppSelector((state) => state?.tenantSlice?.tenantDropDownList?.getTenants?.tenants || []);
  const locationList = useAppSelector((state) => state?.locationSlice?.locationList?.getLocations || []);
  const dispatch = useAppDispatch();
  const [isFacilityUnitAvailable, setIsFacilityUnitAvailable] = useState(true);
  const [currentTenant, setCurrentTenant] = useState<TenantValueType | undefined>(() => {
    // return undefined;
    const tenant = JSON.parse(localStorage.getItem("tenantId") || "{}");
    return tenant?.tenantId ? tenant : undefined;
  });
  const [facilityOption, setFacilityOption] = useState<any>([]);
  const [selectedValueFacility, setSelectedValueFacility] = useState<Partial<SelectedFacilityType>>();
  const [facilityIds, setFacilityIds] = useState<string>();
  const [locationIds, setLocationIds] = useState<string>();
  const [componentData, setComponentData] = useState<ItemType[]>(() => {
    const data = localStorage.getItem('dashboardWidgetOrder');
    return storeComponentData(JSON.parse(data || "[]"));
  });
  const { widgetsSorting } = useAppSelector(store => store?.mainDashboard);
  useEffect(() => {
    const tenant_info = JSON.parse(userData?.tenant_info || "{}");
    if (userData?.tenantCode && tenantDropDownList?.length > 0) {
      const tenantData = tenantDropDownList?.find((tenant: any) => tenant?.tenantCode === userData?.tenantCode)
      setCurrentTenant({
        tenantCode: userData?.tenantCode,
        tenant_name: tenantData?.tenant_name || "",
        tenantId: userData?.tenantId,
      });
    } else if (tenant_info?.tenantCode) {
      const data = {
        tenantCode: tenant_info?.tenantCode,
        tenant_name: tenant_info?.tenant_name,
        tenantId: tenant_info?.tenantId,
      }
      setCurrentTenant(data);
      if (!localStorage.getItem('tenantId')) {
        localStorage.setItem('tenantId', JSON.stringify(data));
      }
    }
  }, [userData, tenantDropDownList]);

  useEffect(() => {
    if (currentTenant?.tenantCode) {
      dispatch(getLocationLists({ tenantId: (currentTenant?.tenantCode) })).then((res) => {
        const facility = res?.payload?.filter((value: any) => value?.type == "F" && !value?.is_unit);
        if (facility?.length <= 0) {
          dispatch(setMainDashboardLoaderFalse());
        }
      });
      dispatch(getSubstabceConfiguration({ tenantCode: (currentTenant?.tenantCode) }))
    }
    return () => {
      dispatch(setMainDashboardInitialState());
    }
  }, [JSON.stringify(currentTenant?.tenantCode)]);

  useEffect(() => {
    const tenantCode = (currentTenant?.tenantCode || userData?.tenantCode)
    const tenantSystemIds = locationList?.filter((value: any) => value?.parentKey === tenantCode)?.map((value: any) => value?.key);
    const facilityList = locationList.filter((item: any) => (tenantSystemIds.includes(item?.parentKey) && item?.type == "F"));
    const facilityUnitList = locationList.filter((item: any) => (tenantSystemIds.includes(item?.parentKey) && item?.type == "FU"));
    setIsFacilityUnitAvailable(!!facilityUnitList?.length)
    setFacilityOption([...facilityList, ...facilityUnitList]);
    // if (userData?.group !== "admin") {
    //   setSelectedValueFacility(facilityList[0])
    // }
  }, [JSON.stringify(locationList), JSON.stringify(userData), currentTenant?.tenantCode]);

  useEffect(() => {
    // if (userData?.group === 'admin')
    dispatch(getTenantDropDownList({}));
  }, [userData?.group]);
  useEffect(() => {
    if (!currentTenant && tenantDropDownList?.length > 0 && userData?.group === 'admin') {
      setCurrentTenant(tenantDropDownList[0]);
    }
  }, [JSON.stringify(tenantDropDownList), userData?.group]);
  useEffect(() => {
    if (widgetsSorting?.length > 0) {
      const data = storeComponentData(widgetsSorting);
      setComponentData(data);
    }
  }, [widgetsSorting]);

  useEffect(() => {
    if (userData?.username) {
      dispatch(getDashboardWidgetsSorting({ username: userData?.username }));
    }
  }, [userData?.username]);

  useEffect(() => {
    if (currentTenant?.tenantCode && locationList?.length > 0) {
      let tempFacilityIds = selectedValueFacility?.type === "F" ? selectedValueFacility?.key : undefined;
      let tempLocationId = undefined;
      if (!tempFacilityIds && selectedValueFacility?.type !== "FU") {
        const systemIds = locationList?.filter((value: any) => value?.parentKey === currentTenant?.tenantCode).map((value: any) => value?.key);
        tempFacilityIds = locationList?.filter((value: any) => systemIds?.includes(value?.parentKey) && value?.type === "F").map((value: any) => value?.key)?.join(",");
      } else if (selectedValueFacility?.type == "FU") {
        tempLocationId = locationList?.filter((value: any) => value?.parentKey === selectedValueFacility?.key).map((value: any) => value?.key).join(",");
      }
      setFacilityIds((!selectedValueFacility?.key ? `all,${tempFacilityIds}` : tempFacilityIds));
      setLocationIds(tempLocationId);
    }
  }, [currentTenant, selectedValueFacility, locationList]);

  const tenantChangedHandler = (_: React.SyntheticEvent<Element, Event>, value: TenantValueType | null) => {
    if (!value?.tenantId) return;
    setSelectedValueFacility(undefined);
    setCurrentTenant(value || undefined);
    dispatch(setMainDashboardInitialState());
    dispatch(setTenantId(value));
    // dispatch(
    //   updateTenantInfoThunk({
    //     tenant_info: JSON.stringify(value),
    //     username: userData?.username,
    //     user: userData,
    //   })
    // );
  }
  const facilityChangedHandler = (_: React.SyntheticEvent<Element, Event>, value: any) => {
    if (!currentTenant?.tenantId && !userData?.tenantId) return;
    // if (value?.type == "FU") {
    //   const rooms = locationList?.filter((loc: any) => value?.key === loc?.parentKey);
    //   if (rooms?.length == 0) {
    //     dispatch(notificationFail("No rooms are added in this group."));
    //     return
    //   }
    // }
    setSelectedValueFacility(value?.key ? value : undefined);
    dispatch(setMainDashboardInitialState());
  }
  const pinComponentHandler = (id: string) => {
    const pinComponent = componentData.find((item) => item.id === id);
    const removePinComponents = componentData.filter((item) => item.id !== id).map((value) => ({ ...value, pin: false }))
    const newOrderData = [{ ...pinComponent!, pin: !pinComponent?.pin }, ...removePinComponents!];
    setComponentData(newOrderData);
    dispatch(saveDashboardWidgetsSorting({ username: userData.username, dashboard_order: JSON.stringify(newOrderData) }));
  }
  return (
    <>
      <CustomHeader title={"Dashboard"}>
        {userData.group === "admin" && <FormControl sx={{ width: "15em", mt: 2 }}>
          <Autocomplete
            options={tenantDropDownList}
            getOptionLabel={(option: any) => option.tenant_name || ""}
            id="demo-simple-select"
            onChange={tenantChangedHandler}
            value={currentTenant ? currentTenant : null}
            isOptionEqualToValue={(option, value) => option?.tenantId === value?.tenantId}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tenant"
                className="custom-input"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </FormControl>}
        <FormControl sx={{ width: "15em", marginLeft: { sm: '1em' }, mt: 2 }}>
          <Autocomplete
            options={[{ name: "All Facilities", key: "" }, ...facilityOption]}
            disableClearable={true}
            getOptionLabel={(option: any) => option.name || ""}
            groupBy={(option: any) => option?.type}
            renderGroup={({ key, group, children, ...params }) => (
              <li {...params} key={key}>
                {group && <div style={{ marginLeft: '0.5rem' }}>
                  <span style={{ marginRight: '0.5rem' }}>
                    <LabelIcons type={group} isUnit={false} />
                  </span>
                  {group === 'FU' ? "Facility Group" : group === 'F' ? "Facility" : ""}
                </div>}
                <ul>{children}</ul>
              </li>
            )}
            id="facility-list"
            onChange={facilityChangedHandler}
            value={selectedValueFacility ? selectedValueFacility : { name: "All Facilities", key: "" }}
            isOptionEqualToValue={(option, value) => option?.key === value?.key}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                className="custom-input"
                label={`Facilities ${isFacilityUnitAvailable ? ' / Groups' : ''}`}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </FormControl>
      </CustomHeader >
      <Box sx={{ marginX: "20px" }}>
        <Pages layout={Layout.Horizontal} items={componentData} setItems={setComponentData} pinComponentHandler={pinComponentHandler} selectedValueFacility={selectedValueFacility?.key} facilityIds={facilityIds} locationIds={locationIds} currentTenant={currentTenant} />
      </Box>
    </>
  );
};
export default Dashboard;

const storeComponentData = (widgetsSortingData: Omit<ItemType, "Component">[]) => {
  const tmpWidgetsSorting = widgetsSortingData ? [...widgetsSortingData] : []
  DEFAULT_COMPONENT_DATA.forEach(value => {
    const exists = tmpWidgetsSorting?.some(item1 => item1.id === value.id);
    if (!exists) {
      tmpWidgetsSorting.push(value);
    }
  });
  const data = tmpWidgetsSorting.map((value) => {
    const Component = COMPONENTS[(value.id as keyof typeof COMPONENTS)];
    return {
      ...value,
      Component,
    }
  });
  return data.filter((value) => !!value?.Component);
}

const COMPONENTS: { [key: string]: ComponentDataType } = {
  EnvironmentalRiskScore: {
    Component: EnvironmentalRiskScore,
    sm: 12, md: 5,
  },
  // DailyAlert: {
  //   Component: DailyAlert,
  //   sm: 12, md: 8,
  // },
  SubstanceFrequency: {
    Component: SubstanceFrequency,
    xs: 12, md: 7,
  },
  RecentNotification: {
    Component: RecentNotification,
    xs: 12, md: 5,
  },
  SubstanceRiskLongevity: {
    Component: SubstanceRiskLongevity,
    xs: 12, md: 7,
  },
  EnvironmentRiskChart: {
    Component: EnvironmentRiskChart,
    sm: 12, md: 12,
  },
}

export const DEFAULT_COMPONENT_DATA = [
  { id: "EnvironmentalRiskScore", Component: COMPONENTS['EnvironmentalRiskScore'], pin: true },
  //// { id: "DailyAlert", Component: COMPONENTS['DailyAlert'], pin: false },
  { id: "SubstanceFrequency", Component: COMPONENTS['SubstanceFrequency'], pin: false },
  { id: "EnvironmentRiskChart", Component: COMPONENTS['EnvironmentRiskChart'], pin: false },
  { id: "SubstanceRiskLongevity", Component: COMPONENTS['SubstanceRiskLongevity'], pin: false },
  { id: "RecentNotification", Component: COMPONENTS['RecentNotification'], pin: false },
];